"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Page Types
 */
var PageTypes = {
  desktop: 'desktop',
  mobile: 'mobile',
  pdf: 'pdf'
};
var _default = exports["default"] = PageTypes;